import { Injectable, InjectionToken, inject } from '@angular/core';
import { initializeApp, FirebaseApp, FirebaseOptions } from 'firebase/app';
import { getFunctions, Functions, connectFunctionsEmulator } from 'firebase/functions';

export interface FirebaseConfig extends FirebaseOptions {
  functionsRegion?: string;
  emulator?: {
    enabled: boolean;
    host?: string;
    port?: number;
  };
}

export const FIREBASE_CONFIG = new InjectionToken<FirebaseConfig>('FIREBASE_CONFIG');

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {
  private config = inject(FIREBASE_CONFIG);

  public readonly app: FirebaseApp = (() => {
    return initializeApp(this.config);
  })();

  public readonly functions: Functions = (() => {
    const functions = getFunctions(this.app, this.config.functionsRegion || 'us-central1');
    
    // Connect to emulator if configured
    if (this.config.emulator?.enabled) {
      const host = this.config.emulator.host || 'localhost';
      const port = this.config.emulator.port || 5001;
      connectFunctionsEmulator(functions, host, port);
    }
    
    return functions;
  })();

  getFunctions(): Functions {
    return this.functions;
  }
}